import { render, staticRenderFns } from "./ListGuidanceCategoryPage.vue?vue&type=template&id=0a47ad3c&"
import script from "./ListGuidanceCategoryPage.vue?vue&type=script&lang=js&"
export * from "./ListGuidanceCategoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports